import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  params: string;
}

export interface PaginationProps {
  currentPage: number;
  quantityPages: number;
  totalItems: number;
  totalItemsPage: number;
}

export interface DataResponse {
  success: boolean;
  notifications: any;
  pagination: PaginationProps | null;
  data: DataProps | null | undefined;
}

export interface DataProps {
  total: number;
  sorteio: number;
  posSorteio: number;
  corretor: boolean;
  checkins: Checkin[];
}

export interface Checkin {
  idCheckin: string;
  idRoletaCheckin: string;
  idPlantaoVendas: string;
  nomePlantaoVendas: string;
  codigoTurno: number;
  turno: string;
  data: string;
  hora: string;
  posSorteio: boolean;
  aoVivo: boolean;
  idCorretor: string;
  nomeCorretor: string;
  emailCorretor: string;
}

interface RequestBody {
  paginaAtual: number;
  totalItensRetorno: number;
  idsPdvs?: string[];
  dataInicio?: string | null;
  dataFim?: string | null;
  idsCorretores?: string[];
  idsSuperintendentes?: string[];
  idsEquipes?: string[];
}

export function useListarCheckin(props: Props & QueryGlobalInterface) {
  const fetchData = async () => {
    const LISTAR_CHECKIN = `${leadsWebEnviroment}/common/checkin/corretor/listar-checkin/v1`;

    // Convertendo os parâmetros de URL para objeto
    const urlParams = new URLSearchParams(props.params);

    // Extraindo os parâmetros necessários
    const paginaAtual = Number(urlParams.get("PaginaAtual") || "1");
    const totalItensRetorno = Number(urlParams.get("TotalItensRetorno") || "5");

    // Criando o body da requisição
    const body: RequestBody = {
      paginaAtual,
      totalItensRetorno,
    };

    // Adicionando parâmetros opcionais se existirem
    const idsPdvs = urlParams.getAll("IdsPdvs");
    if (idsPdvs.length > 0) {
      body.idsPdvs = idsPdvs;
    }

    const dataInicio = urlParams.get("DataInicio");
    if (dataInicio) {
      body.dataInicio = dataInicio;
    }

    const dataFim = urlParams.get("DataFim");
    if (dataFim) {
      body.dataFim = dataFim;
    }

    const idsSuperintendentes = urlParams.getAll("IdsSuperintendentes");
    if (idsSuperintendentes.length > 0) {
      body.idsSuperintendentes = idsSuperintendentes;
    }

    const idsEquipes = urlParams.getAll("IdsEquipes");
    if (idsEquipes.length > 0) {
      body.idsEquipes = idsEquipes;
    }

    const idsCorretores = urlParams.getAll("IdsCorretores");
    if (idsCorretores.length > 0) {
      body.idsCorretores = idsCorretores;
    }

    // Realizando a requisição POST
    const response = await instance.post(LISTAR_CHECKIN, body);

    return (response?.data as DataResponse) || null;
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar dados do Checkin ao Vivo. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
}
